module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot02_american-village-7e1cddb10e950808aababb6d9c7e91b8.jpg";